import posthog from 'posthog-js';

type MissingMarketingAttributionContext = {
  origin: string;
  page_url: string;
  user_agent: string;
};

export const captureMissingMarketingAttribution = (
  context: MissingMarketingAttributionContext,
) => {
  try {
    posthog.capture('marketing_attribution_missing', context);
  } catch {
    // Attribution observability must never block form submission.
  }
};
